module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/bella-poster-86b7b85a6f3420411b5bf7427f48119e.jpg";